import { useEffect } from "react";

export default function Expriences(){
    useEffect(() => {
        const grandpa = document.getElementById('grandpa');
        if (grandpa) {
            const marginBottom = +window.getComputedStyle(grandpa).marginBottom.replace('px', '');
            const totalHeight = grandpa.offsetHeight + marginBottom;
            document.documentElement.style.setProperty('--grandpa-height', totalHeight-25 + 'px');
        }
    }, []);


    return (
        <section className="expriences">
            <h1 className="title">expriences</h1>
            <div className="content">
                <div className="left">
                    <div className="text">My Career Path</div>
                </div>
                <div className="right">
                    <div className="detail-wrapper" id="grandpa">
                        <div className="top">
                            <div className="dot"></div>
                            <div className="company-name">peshgaman</div>
                            <div className="date">
                                <span className="start">2022 Mar </span>
                                -
                                <span className="end"> 2023 May</span>
                            </div>
                        </div>
                        <div className="bottom">
                            <div className="my-role">
                                Full Stack Web Developer
                            </div>
                            <div className="detail">
                                Developed and maintained a dynamic news website using React.js, which aggregated articles from various sources. Implemented a user-friendly interface, ensuring smooth navigation and an intuitive user experience. Integrated external APIs for real-time content updates and advanced search functionality, improving overall user engagement. Enhanced website performance and ensured responsiveness across multiple devices through responsive web design techniques.    
                            </div>
                        </div>
                    </div>
                    <div className="detail-wrapper">
                        <div className="top">
                            <div className="dot"></div>
                            <div className="company-name">WoodlookBr</div>
                            <div className="date">
                                <span className="start">2022 Dec </span>
                                -
                                <span className="end"> 2023 Oct</span>
                            </div>
                        </div>
                        <div className="bottom">
                            <div className="my-role">
                                Full Stack Web Developer
                            </div>
                            <div className="detail">
                                Designed and developed the e-commerce platform woodlook.com.br using Django and React.js, offering a seamless shopping experience for users. Integrated secure payment gateways and optimized product listing pages for better performance and user interaction. Implemented an admin dashboard to manage inventory, orders, and customer interactions efficiently. Enhanced website speed and mobile responsiveness, improving the overall user experience and conversion rates.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="show-more">
                <div className="text">show more</div>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M3.93868 5.85445C4.13395 5.65919 4.45053 5.65919 4.64579 5.85445L7.93872 9.14738C8.13235 9.34101 8.45213 9.34101 8.64575 9.14738L11.9387 5.85445C12.1339 5.65919 12.4505 5.65919 12.6458 5.85445C12.8411 6.04972 12.8411 6.3663 12.6458 6.56156L9.35286 9.85449C8.76871 10.4386 7.81576 10.4386 7.23161 9.85449L3.93868 6.56156C3.74342 6.3663 3.74342 6.04972 3.93868 5.85445Z" fill="white"/>
                </svg>
            </div>
        </section>
    )
}